module.exports = __webpack_public_path__ + "img/246x2461.ef854d33.png";